import type { Message } from "@ai-sdk/react"
import { ErrorHandlerService } from "./ErrorHandlerService"

export class ChatBusinessService {
  static validateMessageBeforeSend(content: string): boolean {
    return content.trim().length > 0;
  }

  static processResponse(response: Response): void {
    console.log("Response received:", response);
  }

  static processFinishedMessage(message: any): void {
    console.log("Final message:", message);
    // Note: Doc sources are already included in the message data from the stream
    // No need to fetch separately
  }

  static checkMessageForErrors(
    messages: Message[], 
    onRemoveMessage: (messageId: string) => void
  ): void {
    const lastMessage = messages[messages.length - 1];
    if (lastMessage && lastMessage.role === "assistant" && lastMessage.content) {
      const content = lastMessage.content;
      console.log("Checking message for errors:", content);
      
      ErrorHandlerService.handleMessageError(content, () => {
        onRemoveMessage(lastMessage.id);
      });
    }
  }

  static handleError(error: Error): void {
    ErrorHandlerService.handleChatError(error);
  }

  static isLoadingState(
    status: "submitted" | "streaming" | "ready" | "error", 
    isManuallyStopped: boolean
  ): boolean {
    return (status === "submitted" || status === "streaming") && !isManuallyStopped;
  }

  static shouldClearMessagesOnDocsetChange(oldDocset: string, newDocset: string): boolean {
    return oldDocset !== newDocset;
  }
} 